var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhonegray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.3334 16.9201V19.9201C22.3346 20.1986 22.2775 20.4743 22.1659 20.7294C22.0544 20.9846 21.8907 21.2137 21.6855 21.402C21.4803 21.5902 21.238 21.7336 20.9742 21.8228C20.7104 21.912 20.4308 21.9452 20.1534 21.9201C17.0763 21.5857 14.1204 20.5342 11.5234 18.8501C9.10726 17.3148 7.05877 15.2663 5.52343 12.8501C3.83341 10.2413 2.78167 7.27109 2.45343 4.1801C2.42844 3.90356 2.4613 3.62486 2.54993 3.36172C2.63856 3.09859 2.781 2.85679 2.9682 2.65172C3.15539 2.44665 3.38323 2.28281 3.63722 2.17062C3.89121 2.05843 4.16577 2.00036 4.44343 2.0001H7.44343C7.92874 1.99532 8.39922 2.16718 8.76719 2.48363C9.13516 2.80008 9.37551 3.23954 9.44343 3.7201C9.57005 4.68016 9.80488 5.62282 10.1434 6.5301C10.278 6.88802 10.3071 7.27701 10.2273 7.65098C10.1476 8.02494 9.96229 8.36821 9.69343 8.6401L8.42343 9.9101C9.84698 12.4136 11.9199 14.4865 14.4234 15.9101L15.6934 14.6401C15.9653 14.3712 16.3086 14.1859 16.6825 14.1062C17.0565 14.0264 17.4455 14.0556 17.8034 14.1901C18.7107 14.5286 19.6534 14.7635 20.6134 14.8901C21.0992 14.9586 21.5428 15.2033 21.86 15.5776C22.1771 15.9519 22.3456 16.4297 22.3334 16.9201Z",
    stroke: "#B5B5B5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonegray);
export default __webpack_public_path__ + "static/media/phonegray.088848662b2735c4e07a80b232c3d687.svg";
export { ForwardRef as ReactComponent };